export * from '@kunk/core'
import { save } from "./actions/save";
import { create } from "./actions/create";
import { update } from "./actions/update";
import { remove } from "./actions/remove";
import { detail } from "./queries/detail";
import { search } from "./queries/search";

export * from "./api";

export * from "./middlewares/useCrud";
export * from "./middlewares/useEvents";
export * from "./middlewares/usePublishers";

export { Aggregate } from "./Aggregate";
export * from "./tags";
export * from "./types";

export type Action = {};
export const Action = {
  create,
  update,
  remove,
  save,
};

export type Query = {};
export const Query = {
  detail,
  search,
};
